import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './index.css';
import { useDispatch } from 'react-redux';
import { clearOrderList } from '../../../redux/locallCartSlice';
import { trackOrderStatus } from '../../../utility/analyticsUtility';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [countdown, setCountdown] = useState(6);

  useEffect(() => {
    const customerId = searchParams.get('customerId');
    const orderId = searchParams.get('orderId');
    const orderValue = parseFloat(searchParams.get('orderValue') || '0');
    const paymentMethod = searchParams.get('paymentMethod') || 'Card';

    // Track successful payment
    if (orderId) {
      trackOrderStatus('success', {
        orderId: orderId,
        orderValue: orderValue,
        paymentMethod: paymentMethod,
      });
    }

    dispatch(clearOrderList());

    const countdownInterval = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate(`/order-details?customerId=${customerId}&orderId=${orderId}`);
    }, 6000);

    return () => {
      clearInterval(countdownInterval);
      clearTimeout(redirectTimer);
    };
  }, [navigate, searchParams, dispatch]);

  // const handleViewOrderNow = () => {
  //   const customerId = searchParams.get('customerId');
  //   const orderId = searchParams.get('orderId');
  //   navigate(`/order-details?customerId=${customerId}&orderId=${orderId}`);
  // };

  return (
    <Container fluid className="payment-success-container d-flex align-items-center justify-content-center">
      <Row className="w-100 justify-content-center">
        <Col md={6} lg={5}>
          <Card className="success-card border-0">
            <Card.Body className="p-4 p-md-5 text-center">

              {/* Success Icon */}
              <div className="mb-4">
                <div className="success-icon d-inline-flex align-items-center justify-content-center rounded-circle mb-3">
                  <div className="check-mark"></div>
                </div>
              </div>

              {/* Success Message */}
              <h2 className="text-success fw-bold mb-3">Your Payment has been Successful!</h2>
              <p className="text-muted mb-4">
                Thank you for your payment. Your order has been confirmed and will be processed shortly.
              </p>

               <p className="text-muted mb-2 fw-medium">Redirecting to order details page ...</p>

              {/* Countdown Section */}
              {/* <Card className="countdown-card mb-4">
                <Card.Body className="py-3">
                 
                  <div className="countdown-number mb-3">{countdown}</div>
                  <ProgressBar
                    now={((6 - countdown) / 6) * 100}
                    className="progress-bar-custom rounded"
                    variant="success"
                  />
                </Card.Body>
              </Card> */}

              {/* Action Button */}
              {/* <Button
                variant="success"
                size="lg"
                className="action-button w-100 fw-semibold"
                onClick={handleViewOrderNow}
              >
                View Order Details Now →
              </Button> */}

              {/* <p className="confirmation-text mt-3">
                A confirmation email has been sent to your registered email
              </p> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentSuccess;
